import { Vue } from 'Common/vue';
import ShippingInfo from 'Components/vue/ShippingInfo.vue';

import Swiper, { Pagination, Navigation } from 'swiper';
import { buildStars, initRatingForm, initUsefulRatingVote } from 'Functions/rating';

import 'Layouts/default';

import 'Ui/slider';
import 'Ui/tabs';
import 'Ui/favorite-trigger';

import 'Common/lightgallery';
import 'Common/social';

import 'Components/seen-products';
import 'Components/modal/modal-remote';
import 'Components/modal/modal-watchdog';

Swiper.use([Pagination, Navigation]);

const $ = window.jQuery;

buildStars()
initRatingForm()
initUsefulRatingVote()

document.querySelectorAll('[data-has-component="shippingInfo"]').forEach(element => {
    new Vue({
        el: element,
        components: {
            ShippingInfo
        }
    })

    element.removeAttribute('data-has-component')
});

if (document.querySelector('.js-set-tabs-arrow')) {
    document.querySelector('.js-set-tabs-arrow').addEventListener('click', () => {
        const navWrapper = document.querySelector('.js-set-tabs-nav');
        const navWrapperInfo = navWrapper.getBoundingClientRect();
        const activeNavItem = navWrapper.querySelector('.c-set-tabs__trigger.is-active');
        const navItemsCount = navWrapper.querySelectorAll('.c-set-tabs__trigger').length;
        const nextNavItemIndex = parseInt(activeNavItem.dataset.tabId) + 1 >= navItemsCount ? 0 : parseInt(activeNavItem.dataset.tabId) + 1;
        const nextNavItem = navWrapper.querySelector(`.c-set-tabs__trigger[data-tab-id="${nextNavItemIndex}"]`);
        const nextNavItemInfo = nextNavItem.getBoundingClientRect();

        nextNavItem.click();

        navWrapper.scrollTo({
            left: navWrapper.scrollLeft + nextNavItemInfo.x - navWrapperInfo.x,
            top: 0,
            behavior: 'smooth'
        });
    });
}

if (document.querySelector('.js-countdown')) {
    import('Functions/countdown').then(({ initCountdowns }) => {
        initCountdowns();
    });
}